import ubigeoData from '../data/ubigeo.json'

type UbigeoJson = Record<string, {
  name: string
  provinces: Record<string, {
    name: string
    districts: Record<string, { name: string }>
  }>
}>

const data = ubigeoData as UbigeoJson

/**
 * Resolves a 6-digit ubigeo code to "Departamento / Provincia / Distrito".
 * Returns fallback text for null/invalid codes.
 */
export function resolveUbigeoLabel(code: string | null | undefined): string {
  if (!code || code.length < 2) return 'Sin ubicacion'

  const deptoCode = code.substring(0, 2)
  const depto = data[deptoCode]
  if (!depto) return code

  if (code.length < 4) return depto.name

  const provCode = code.substring(0, 4)
  const prov = depto.provinces[provCode]
  if (!prov) return depto.name

  if (code.length < 6) return `${depto.name} / ${prov.name}`

  const dist = prov.districts[code]
  if (!dist) return `${depto.name} / ${prov.name}`

  return `${depto.name} / ${prov.name} / ${dist.name}`
}
